import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppTableComponent, AssessmentAreaBasicModel, AssessmentAreasService, Auth, Form, FormElement, MessagesComponent, OpnOfferEvaluationMethodModel, OpnOfferEvaluationMethodSaveModel, RequestsService, TranslationManager, UtilValidator, ViewState } from 'src/common';
import { OpnElementViewModel } from 'src/views';

@Component({
  selector: 'opn-offer-evaluation-method',
  templateUrl: 'opn-offer-evaluation-method.component.html'
})

export class OpnOfferEvaluationMethodComponent implements OnInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;

  @Input() state: ViewState;
	viewState = ViewState;
	form: Form = new Form();

	private _element: OpnElementViewModel;
  @Input() set element(value: OpnElementViewModel) {
		this._element = value;
		this._element.isValid = this.isValid.bind(this);
		this._element.getElement = this.getElement.bind(this);
    }

    isValid(): boolean {
      return this.form.isValid();
    }

    getElement(): OpnOfferEvaluationMethodModel {
      this.mapFormToElement();
      return this._element.element;
    }

    delete() {
      this._element.delete(this._element);
    }

  assessmentAreas: AssessmentAreaBasicModel[];
  items: OpnOfferEvaluationMethodModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;

  auth = Auth;
  translationManager = TranslationManager;

  constructor(private assessmentAreasService: AssessmentAreasService) { }

  ngOnInit(): void {
    this.initForm();

    this.assessmentAreasService.getAll().then((items: AssessmentAreaBasicModel[]) => {
      this.assessmentAreas = items;
    });
  }

  private initForm(): void {
    this.form.elements["assessmentAreaId"] = new FormElement();
    this.form.elements["assessmentAreaId"].state.mandatory = true;
    this.form.elements["description"] = new FormElement();
    this.form.elements["description"].state.mandatory = true;
    this.form.elements["points"] = new FormElement();
    this.form.elements["points"].state.mandatory = true;
  }

  private mapFormToElement() {
    let model: OpnOfferEvaluationMethodModel = this._element.element as OpnOfferEvaluationMethodModel;

    model.assessmentAreaId = this.form.elements['assessmentAreaId'].value;
    model.description = this.form.elements['description'].value;
    model.points = this.form.elements['points'].value;
  }

  changeAssessmentArea(id: number) {
    this.form.elements['assessmentAreaId'].value = id;
  }

  checkNumberKeyDown(e: any, value: string) {
    if (e.keyCode == 190 && value.toString().indexOf('.') < 0) {  return true; }
    return UtilValidator.checkNumberKeyDown(e);
  }
}
